import { __extends } from "tslib";
import React, { Component } from 'react';
import { FaTimes } from 'react-icons/fa';
var SendMailBody = /** @class */ (function (_super) {
    __extends(SendMailBody, _super);
    function SendMailBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            emails: [],
            currentMail: '',
            error: null
        };
        _this.onAdd = function () {
            var emails = _this.state.emails;
            if (_this._validateEmail(_this.state.currentMail)) {
                emails.push(_this.state.currentMail);
                _this.setState({ currentMail: '', emails: emails, error: null });
            }
            else {
                _this.setState({ error: 'Please type a valid email' });
            }
        };
        _this.onRemove = function (index) {
            var emails = _this.state.emails;
            emails.splice(index, 1);
            _this.setState({ currentMail: '', emails: emails });
        };
        _this.onSend = function () {
            if (_this.props.sendEmails) {
                _this.props.sendEmails(_this.props.appOrderId, _this.state.emails);
                _this.setState({
                    emails: [],
                    currentMail: '',
                    error: null
                });
            }
        };
        _this._handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                _this.onAdd();
            }
        };
        return _this;
    }
    SendMailBody.prototype.componentDidMount = function () {
        if (this.props.sellToContactEMail) {
            this.setState({
                emails: [this.props.sellToContactEMail]
            });
        }
    };
    SendMailBody.prototype._validateEmail = function (mail) {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
            return (true);
        }
        return (false);
    };
    SendMailBody.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "send-email" },
            React.createElement("h2", null, "Send order review links to the following"),
            React.createElement("h3", null),
            React.createElement("div", null,
                React.createElement("div", { className: "form-control" },
                    React.createElement("label", null, "Email:"),
                    React.createElement("input", { type: "email", name: "email", placeholder: 'Insert email here', value: this.state.currentMail, onKeyDown: this._handleKeyDown, onChange: function (event) {
                            var value = event.target.value;
                            _this.setState({ currentMail: value });
                        } }),
                    this.state.error && React.createElement("div", { className: "error-message" }, this.state.error)),
                React.createElement("div", { className: "form-control", style: { display: 'flex', justifyContent: 'flex-end' } },
                    React.createElement("button", { className: "send-email__button", onClick: this.onAdd }, "Add"))),
            React.createElement("div", { className: "form-control" }, this.state.emails.map(function (mail, key) {
                return (React.createElement("div", { className: "options", key: key },
                    React.createElement("div", { className: "options__item --large-text" },
                        React.createElement("span", null, mail),
                        React.createElement("span", { className: "options__item__icon", onClick: function () { return _this.onRemove(key); } },
                            React.createElement(FaTimes, null)))));
            })),
            this.state.emails.length ?
                React.createElement("div", { className: "form-control", style: { display: 'flex', justifyContent: 'flex-end', marginTop: '40px' } },
                    React.createElement("button", { className: "send-email__button", onClick: this.onSend }, "Send mails")) : null));
    };
    return SendMailBody;
}(Component));
export { SendMailBody };
//# sourceMappingURL=SendMailBody.js.map